export default __webpack_public_path__ + "static/media/copy.9d323dc9.svg";